import React from "react";
import { Alert, Box } from "@mui/material";

import { TOO_MANY_FEATURES_THRESHOLD } from "fond/draw/modes/cts/helper";
import MapPopup from "fond/map/MapPopup";

interface TooManyFeaturesPopupProps {
  map: mapboxgl.Map | undefined;
  popupPosition: { lng: number; lat: number } | null;
  exceededFeatureCount: number;
  onClose: () => void;
}

const TooManyFeaturesPopup: React.FC<TooManyFeaturesPopupProps> = ({ map, popupPosition, exceededFeatureCount, onClose }) => {
  if (!map || !popupPosition) {
    return null;
  }

  return (
    <MapPopup title="Too many features selected" lngLat={popupPosition} onClose={onClose} showCloseIcon>
      <Box sx={{ padding: 1 }}>
        <Alert severity="warning">
          You have selected {exceededFeatureCount.toLocaleString()} features, which exceeds the limit of{" "}
          {TOO_MANY_FEATURES_THRESHOLD.toLocaleString()}. Please select fewer features and prioritize them in smaller batches.
        </Alert>
      </Box>
    </MapPopup>
  );
};

export default TooManyFeaturesPopup;
